import { Component, inject, viewChild } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { NovaButton } from '@rds-nova/angular-button';
import { NovaIcon } from '@rds-nova/angular-icon';
import { MatMenuModule } from '@angular/material/menu';
import { Store } from '@ngrx/store';

import { AppState } from 'src/app/store';
import { selectParticipantFullName } from 'src/app/features/session/store/selectors/session.selectors';
import { DEFAULT_APPLICATION_PHONE_NUMBER } from 'src/app/shared/constants';
import { ScreenSizeService } from 'src/app/shared/services/screen-size.service';

import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { ExitSigningModalComponent } from '../exit-signing-modal/exit-signing-modal.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';
import { TrackedButtonDirective } from 'src/app/core/analytics/directives/tracked-button.directive';

@Component({
  selector: 'app-header',
  imports: [
    TranslatePipe,
    LanguageSelectorComponent,
    UserMenuComponent,
    NovaButton,
    NovaIcon,
    MatMenuModule,
    ExitSigningModalComponent,
    TrackedButtonDirective,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  private readonly store = inject(Store<AppState>);
  protected screenSize = inject(ScreenSizeService);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  exitModal = viewChild<ExitSigningModalComponent>('exitModal');

  readonly phoneNumber = DEFAULT_APPLICATION_PHONE_NUMBER;
  readonly participantName = this.store.selectSignal(selectParticipantFullName);

  get participantInitial(): string {
    const name = this.participantName();
    return name ? name.charAt(0).toUpperCase() : '';
  }

  isExitSigningHeader = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => this.getRouteData('exitSigningHeader') === true)
    ),
    { initialValue: this.getRouteData('exitSigningHeader') === true }
  );

  private getRouteData(key: string): boolean | undefined {
    let route = this.activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.data[key];
  }

  callSupport(): void {
    window.location.href = 'tel:' + this.phoneNumber;
  }

  exitSigning(): void {
    this.exitModal()?.open();
  }
}
